const sendEvent = data => {
  if (typeof window !== 'undefined' && window.dataLayer !== undefined) {
    window.dataLayer.push({ ...data })
  }
}

export const trackCustomGTMEvents = ({ eventData }) => {
  const data = {
    ...eventData,
  }
  sendEvent(data)
}
